export default "__VITE_ASSET__CimQNGG6__"